import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const DefaultDepositLimitsWrapper = styled('div', { label: 'DefaultDepositLimitsWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: var(--font-family-primary);
`;

export const DefaultDepositLimitsFormLayout = styled('form', { label: 'DefaultDepositLimitsFormLayout' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DefaultDepositLimitsPanel = styled('div', { label: 'DefaultDepositLimitsPanel' })`
    display: flex;
    flex-direction: column;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.default.light};
`;

export const DefaultDepositLimitsToolbar = styled('div', { label: 'DefaultDepositLimitsToolbar' })`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid ${mainColors.grays.gray200};
`;

export const DefaultDepositLimitsTableWrap = styled('div', { label: 'DefaultDepositLimitsTableWrap' })`
    overflow: visible;

    tbody > tr > td {
        border-bottom: 0;
        overflow: visible;
    }

    tbody > tr[data-group-end='true']:not([data-last-group='true']) > td {
        border-bottom: 1px solid #cfcfcf;
    }
`;

export const DefaultDepositLimitsEmpty = styled('p', { label: 'DefaultDepositLimitsEmpty' })`
    margin: 0;
    padding: 16px 20px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray400};
`;

export const DefaultDepositLimitsAmountGroup = styled('div', { label: 'DefaultDepositLimitsAmountGroup' })`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    width: 100%;
`;

export const DefaultDepositLimitsPeriodCell = styled('div', { label: 'DefaultDepositLimitsPeriodCell' })`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
`;

export const DefaultDepositLimitsRowLabel = styled('span', { label: 'DefaultDepositLimitsRowLabel' })<{ variant: 'net' | 'gross' }>`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 52px;
    height: 36px;
    padding: 0 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    color: ${({ variant }): string =>
        variant === 'gross' ? mainColors.status.warning : mainColors.extendedSecondary.secondary400};
    background-color: ${({ variant }): string =>
        variant === 'gross' ? mainColors.status.scheduled : mainColors.extendedSecondary.secondary100};
`;

export const DefaultDepositLimitsAmountRow = styled('div', { label: 'DefaultDepositLimitsAmountRow' })`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const DefaultDepositLimitsAmountLine = styled('div', { label: 'DefaultDepositLimitsAmountLine' })`
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
`;

export const DefaultDepositLimitsAmountLabel = styled('span', { label: 'DefaultDepositLimitsAmountLabel' })`
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    color: ${mainColors.grays.gray400};
`;

export const DefaultDepositLimitsAmountCell = styled('div', { label: 'DefaultDepositLimitsAmountCell' })`
    display: flex;
    align-items: flex-start;
    gap: 0;
    width: 100%;
    min-height: 36px;
    padding: 0 10px;
    border: 1px solid ${mainColors.grays.gray300};
    border-radius: 6px;
    background-color: ${mainColors.default.light};

    &:focus-within {
        border-color: ${mainColors.grays.gray400};
    }

    &[data-invalid='true'] {
        border-color: ${mainColors.status.error};
    }
`;

export const DefaultDepositLimitsAmountInput = styled('div', { label: 'DefaultDepositLimitsAmountInput' })`
    flex: 1;
    min-width: 0;

    > div {
        flex: none;
        gap: 0;
    }

    && input {
        height: 34px;
        border: 0;
        border-radius: 0;
        box-shadow: none;
        outline: none;
        padding: 0 0 0 6px;
        background: transparent;
    }

    && input:focus,
    && input:focus-visible {
        border: 0;
        box-shadow: none;
        outline: none;
    }
`;

export const DefaultDepositLimitsCurrencyPrefix = styled('span', { label: 'DefaultDepositLimitsCurrencyPrefix' })`
    display: flex;
    align-items: center;
    height: 34px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1;
    color: ${mainColors.grays.gray400};
    flex-shrink: 0;
`;

export const DefaultDepositLimitsAgeSwitch = styled('div', { label: 'DefaultDepositLimitsAgeSwitch' })`
    flex-shrink: 0;
    white-space: nowrap;

    label {
        min-height: 36px;
    }
`;

export const DefaultDepositLimitsCalculationField = styled('div', { label: 'DefaultDepositLimitsCalculationField' })`
    width: 100%;
`;

export const DefaultDepositLimitsUnavailable = styled('span', { label: 'DefaultDepositLimitsUnavailable' })`
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 14px;
    line-height: 1;
    margin-left: 14px;
    color: ${mainColors.grays.gray400};
`;

export const DefaultDepositLimitsPeriod = styled('span', { label: 'DefaultDepositLimitsPeriod' })`
    font-size: 13px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.main.primary};
    white-space: nowrap;
`;

export const DefaultDepositLimitsCreatePanel = styled('div', { label: 'DefaultDepositLimitsCreatePanel' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 20px 20px;
    border: 1px dashed ${mainColors.extendedSecondary.secondary300};
    border-radius: 8px;
    background-color: ${mainColors.extendedSecondary.secondary100};
`;

export const DefaultDepositLimitsCreateBlock = styled('div', { label: 'DefaultDepositLimitsCreateBlock' })`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const DefaultDepositLimitsCreateFields = styled('div', { label: 'DefaultDepositLimitsCreateFields' })`
    display: grid;
    width: max-content;
    grid-template-columns: 180px 360px 180px 180px max-content;
    gap: 12px;
    align-items: center;
`;

export const DefaultDepositLimitsCreateAmount = styled('div', { label: 'DefaultDepositLimitsCreateAmount' })`
    width: 360px;
    max-width: 360px;
`;

export const DefaultDepositLimitsCustomHint = styled('p', { label: 'DefaultDepositLimitsCustomHint' })`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
    color: ${mainColors.main.primary};
`;

export const DefaultDepositLimitsDaysField = styled('div', { label: 'DefaultDepositLimitsDaysField' })`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const DefaultDepositLimitsLockedTooltipWrap = styled('div', { label: 'DefaultDepositLimitsLockedTooltipWrap' })`
    width: 100%;
    cursor: not-allowed;

    & > span {
        display: block;
        width: 100%;
        cursor: not-allowed;
        text-decoration: none;
    }
`;

export const DefaultDepositLimitsLockedField = styled('div', { label: 'DefaultDepositLimitsLockedField' })`
    display: flex;
    align-items: center;
    min-height: 36px;
    width: 100%;
    padding: 0 12px;
    border: 1px solid ${mainColors.grays.gray300};
    border-radius: 6px;
    background-color: ${mainColors.grays.gray100};
    cursor: not-allowed;
    opacity: 0.85;
`;

export const DefaultDepositLimitsLockedValue = styled('span', { label: 'DefaultDepositLimitsLockedValue' })`
    display: flex;
    align-items: center;
    min-height: 36px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.43;
    color: ${mainColors.grays.gray400};
    white-space: nowrap;
    cursor: not-allowed;
`;

export const DefaultDepositLimitsActions = styled('div', { label: 'DefaultDepositLimitsActions' })`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
`;
